
Vue.component('streamerTournament', {
    template: templates.streamerTournament,
    data() {
      return {
        model: {
            state: false,
            selectedTournament: [],
            teamName: null,
            cooldown: null,
            intervalId: null,
        
            expandedRow: null,
            showTimer: null,
            hasResults: true
        },
        cancelTokenSource: null
      };
    },
    created() {
      const c = this;
      c.connect();
    },
    mounted() {
      const c = this;
      c.$root.$on('tournament_saved', data  => {
        c.get();
      });
      c.get();
    },
    beforeDestroy() {
      const c= this;

      if (c.ws) {
        c.ws.close();
      }
      // c.stopSendingData();
      if (c.cancelTokenSource) {
        c.cancelTokenSource.cancel('Request canceled due to component destruction.');
      }
    },
    methods: {
        connect() {
        const c = this;
        c.ws = new WebSocket(utils.getWsUrl());

        c.ws.onmessage = (event) => {
            // c.messages.push(event.data);
        };

        c.ws.onopen = () => {
            console.log('WebSocket connection established');
        };

        c.ws.onclose = () => {
            console.log('WebSocket connection closed');
        };
        },
        sendMessage(state) {
        
            const c = this;

            const messageData = {
            to: utils.cookies.get('user_id'),
            channelId: utils.cookies.get('channelId'),
            message: state,
            data: c.model.selectedTournament[0]
            };
        
            c.ws.send(JSON.stringify(messageData));
        
        },
        get() {
            const c = this;

            tournamentService.getActive()
            .then((res) => {
                //   utils.alert.success(`${res.data[0].name} Tournament is now Open`);
                //   console.log(res.data[0])
                if(res.data.status === 400){
                    c.model.state = false;
                    c.model.selectedTournament = []
                }
                else{
                    let val = parseInt(res.data[0].isOpen);
              
                    c.model.state = val === 1 ? true : false;
                    c.model.selectedTournament = res.data
                }
                  
          
           
            })
            .catch((error) => {
              // console.log(error);
            });
        },
        stopTournament(){
            const c = this;
            let data = {
                tournamentId: c.model.selectedTournament[0].id,
                channelId: utils.cookies.get('user_id'),
                isOpen: false,
            };

            tournamentService.toggleOpenCloseTournament(data)
            .then((res) => {
                console.log(res);
              if(res.data.status === 400){
                  utils.alert.error(res.data.message);
              }
              else{
                    c.model.state = false;
                    utils.alert.error(`${c.model.selectedTournament[0].name} Tournament is Closed!`);
                    c.sendMessage('tournament_off')
              }
            })
            .catch((error) => {
              // console.log(error);
            });
        },
        startTournament(){

            const c = this;

            console.log(c.model)

            if(c.model.selectedTournament.length === 0){

                utils.alert.error('No ative tournament');

                return;
            }
        
            let data = {
                tournamentId: c.model.selectedTournament[0].id,
                channelId: utils.cookies.get('user_id'),
                isOpen: true,
            };

            tournamentService.toggleOpenCloseTournament(data)
            .then((res) => {
                console.log(res);
              if(res.data.status === 400){
                  utils.alert.error(res.data.message);
              }
              else{
    
                    utils.alert.success(`${c.model.selectedTournament[0].name} Tournament is now Open`);
                    c.model.state = true;
                    console.log(c.model);
                    c.sendMessage('tournament_on')
              }
            })
            .catch((error) => {
              // console.log(error);
            });
        
        }
    }
     
  });
  